// src/lib/authService.js - FIXED: Added options parameter for invitation metadata
import supabase from '../lib/supabaseClient';

export const signUpUser = async (email, password, options = {}) => {
  const signUpData = {
    email,
    password
  };

  // Add options if provided (for invitation metadata)
  if (options.data) {
    signUpData.options = {
      data: options.data
    };
  }

  console.log('🚀 Signing up user with data:', signUpData);
  
  return supabase.auth.signUp(signUpData);
};

export const signInUser = async (email, password) => {
  // Call backend endpoint for audit logging
  const response = await fetch('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    // `code` lets the sign-in page tell "this demo has ended" and "wrong password" apart from a genuine failure
    throw Object.assign(new Error(errorData.error || 'Login failed'), { code: errorData.code || null, status: response.status });
  }

  const { session, user } = await response.json();

  // Set the session in Supabase client for frontend auth state
  const { error } = await supabase.auth.setSession({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
  });

  if (error) {
    throw error;
  }

  return { data: { session, user }, error: null };
};

export const signOutUser = async () => {
  // Get current session for audit logging
  const { data: { session } } = await supabase.auth.getSession();

  if (session?.access_token) {
    // Call backend logout endpoint for audit logging
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session.access_token}`,
        },
      });
    } catch (error) {
      console.error('Failed to log logout event:', error);
      // Continue with logout even if audit logging fails
    }
  }

  // Clear local session
  return supabase.auth.signOut();
};

export const getCurrentUser = async () => {
  const { data, error } = await supabase.auth.getUser();
  if (error) {
    console.error('Error getting current user:', error.message);
    return null;
  }
  return data?.user;
};

export const onAuthStateChange = (callback) => {
  const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
    // The callback can be called with the user directly from the session
    // or with the entire session object, depending on what the app needs.
    // For simplicity, let's pass the user object.
    callback(session?.user || null);
  });
  // Return the listener so it can be unsubscribed if needed
  return authListener;
};